import { createBasicLocation, ILocation } from "src/router/routeTypes"

const Inbox = createBasicLocation("/inbox")

const InboxConversation: ILocation<string> = {
  location(conversationId) {
    const pathname = `${Inbox.location().pathname}/${conversationId}`
    return { pathname }
  },
} as const

export const InboxRoutes = {
  Inbox,
  InboxConversation,
} as const
